import { classnames, getInitials } from 'helpers/utils';
import styles from './drop-down-list-header.module.scss';

interface DropDownListHeaderProps {
  name?: string;
  email?: string;
  avatar?: string;
  title?: string;
}

export const DropDownListHeader = ({
  name,
  email,
  avatar,
  title,
}: DropDownListHeaderProps) =>
  !title ? (
    <div className={styles.container}>
      <div className={styles.avatarContainer}>
        {avatar ? (
          <img src={avatar} alt="" />
        ) : (
          <div
            className={classnames(
              styles.avatarInitials,
              'text__body__semi__bold__medium__gray500',
            )}
          >
            {getInitials(name || '').replace(' ', '')}
          </div>
        )}
      </div>
      <div className={styles.userInfoContainer}>
        <span className="text__body__semi__bold__medium__gray900">{name}</span>
        <span
          className={classnames(
            styles.email,
            'text__body__regular__small__gray600',
          )}
          title={email}
        >
          {email}
        </span>
      </div>
    </div>
  ) : (
    <div className={styles.onlyTitleContainer}>
      <span className="text__body__semi__bold__medium__gray700">{title}</span>
    </div>
  );
